<template>
    <div class="ticket-holder">
        <div class="bp-card" data-clickthrough="link">
            <div class="bp-card_label">
                <div class="bd-border_solid"></div>
                <div class="bd-border_dotted"></div>
            </div>
            <div class="bp-card_content">
                <div class="row">
                    <div class="col-md-6">
                        <p class="secondary">Booking Reference: {{ participant.reference }}</p>
                        <h4>
                            <font-awesome-icon :icon="icons.user"></font-awesome-icon>
                            {{ participant | fullName }}
                        </h4>
                        <p v-if="participant.registration_category.checkout_complete_note">Note:
                            {{ participant.registration_category.checkout_complete_note }}</p>
                        <ul>
                            <span>Booking Includes:</span>
                            <li>
                                <span
                                    v-if="participant.hasOwnProperty('ticket')">{{
                                        participant.ticket.summary_name
                                    }}</span>
                            </li>
                            <li v-for="(order, orderIndex) in participant.orders" :key="orderIndex">
                                {{ order.quantity }} x {{ order.name }}
                            </li>
                            <li v-for="(donation, donationIndex) in participant.donations"
                                :key="donationIndex">
                                <span
                                    v-if="donation.donation_status == 'complete'">{{
                                        donation.amount | money(donation.currency)
                                    }}</span>
                                Donation To: {{ donation.hasOwnProperty('charity') ? donation.charity.name : '' }}
                            </li>
                            <li v-if="participant.hasOwnProperty('policy_holder') && participant.policy_holder !== null">
                                Insured booking with {{ participant.policy_holder.insurance_policy.policy_name }}
                            </li>
                        </ul>

                    </div>
                    <div class="col-md-6 text-right">
                        <slot name="qrcode">

                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faUser, faTicketAlt} from '@fortawesome/free-solid-svg-icons'
import {money} from '../Utility/filters/money'

export default {
    name: "complete-participant-ticket",
    props: {
        participant: {
            type: Object
        }
    },
    components: {
        FontAwesomeIcon,
    },
    data() {
        return {
            icons: {
                user: faUser,
                ticket: faTicketAlt,
            }
        }
    },
    filters: {
        money,
        fullName({first_name, last_name}) {
            return `${first_name} ${last_name}`
        }
    },
}
</script>

<style lang="scss" scoped>
$label-width: 130px;
$label-height: 60px;
$secondary: #FFAF96;
$lightgrey: #F0F0F0;

.ticket-holder {
    padding: 20px;
    background: #e4e3e3;
    border: 1px solid #cacaca;
}

body {
    background: #f0f0f0;
    font-size: 17px;
}

.container {
    max-width: 900px;
    width: 92%;
    margin: 50px auto 50px auto;
}

* {
    box-sizing: border-box;
}

.bp-card {
    position: relative;

    &:not(:last-child) {
        margin-bottom: 30px;
    }

    // label
    .bp-card_label {
        position: absolute;
        top: 30px;
        left: 0;
        bottom: 30px;
        width: $label-width;
        background: white;
        cursor: pointer;

        // edges
        &::before {
            content: '';
            background-color: transparent;
            background-image: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/372262/ticket-top.svg');
            background-size: contain;
            background-repeat: no-repeat;
            width: $label-width;
            height: 100px;
            position: absolute;
            top: -30px;
            left: 0;
        }

        &::after {
            content: '';
            background-image: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/372262/ticket-bottom.svg');
            background-size: contain;
            background-position: bottom left;
            background-repeat: no-repeat;
            width: $label-width;
            height: 100px;
            position: absolute;
            bottom: -30px;
            left: 0;
        }

        // lines
        .bd-border_dotted {
            content: '';
            width: 0px;
            border-right: 5px dashed $lightgrey;
            height: 100%;
            position: absolute;
            top: 0;
            right: 40px;
        }

        .bd-border_solid {
            content: '';
            width: 3px;
            border-radius: 3px;
            background: $secondary;
            height: 100%;
            position: absolute;
            top: 0;
            left: calc(#{$label-width} / 3.1);
        }
    }

    // content
    .bp-card_content {
        position: relative;
        background: white;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        width: calc(100% - #{$label-width});
        margin-left: calc(#{$label-width} - 1px);
        padding: 35px;

        h4 {

        }

        p.secondary {
            color: $secondary;
            margin: 0;
            padding-top: 10px;
        }

        ul {
            margin: 20px 0 0 0;
            padding: 0;

            li {
                padding: 0;
                margin-left: 20px
            }
        }

        a.price {
            color: $secondary;
            text-decoration: none;
            position: absolute;
            top: 35px;
            right: 35px;
            font-size: 36px;
            background: transparentize($secondary, 0.9);
            padding: 10px;
            border-radius: 3px;
        }
    }
}

@media only screen and (max-width: 600px) {

    .bp-card {
        position: relative;

        // label
        .bp-card_label {
            top: 0;
            left: 0;
            bottom: 0;
            width: calc(100% - 40px);
            margin-left: 20px;
            height: 120px;
            position: relative;

            // sides;
            &:after, &:before {
                transform: rotate(90deg);
                transform-origin: top left;
                width: 126px;
                top: -2px;
            }

            &:after {
                left: 80px;
                right: auto;
            }

            &:before {
                left: auto;
                right: -146px;
            }

            .bd-border_dotted {
                width: 100%;
                border-top: 4px dashed $lightgrey;
                border-right: none;
                height: 4px;
                top: 92px;
                left: 0;
            }

            .bd-border_solid {
                width: 80%;
                background: $secondary;
                height: 3px;
                top: 45px;
                left: 10%;
            }
        }

        // content
        .bp-card_content {
            margin-left: 0;
            width: 100%;
            padding: 3% 5% 5% 5%;
            text-align: center;

            // title
            h4 {
                font-size: 16px;
                margin: 0;
            }

            // usp's
            ul {
                text-align: left;
                list-style: disc;
                margin: 20px 0 0 0;
                padding: 0;

                li {
                    padding: 0;
                    width: 100%;
                    padding-right: 30px;
                    margin-bottom: 5px;
                }
            }

            // price
            a.price {
                position: relative;
                width: 100%;
                display: block;
                margin: 0 auto;
                top: auto;
                right: auto;
                margin-top: 20px;
                text-align: center;

                // pijltje
                &:before {
                    content: '';
                    background: url('http://imgh.us/i-arrow.svg') center no-repeat;
                    background-size: contain;
                    position: absolute;
                    right: 22px;
                    top: 22px;
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/Participants/CompleteTicket.vue